import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('UI crash:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: 'system-ui' }}>
          <div style={{ maxWidth: 520 }}>
            <h1 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Erreur d'affichage</h1>
            <p style={{ fontSize: 13, color: '#64748b', marginBottom: 12 }}>
              Une erreur JavaScript empêche le rendu du portail. Ouvrez la console (F12) pour le détail.
            </p>
            <pre style={{ background: '#0f172a', color: '#fda4af', padding: 12, borderRadius: 12, fontSize: 11, overflow: 'auto' }}>
              {String(this.state.error?.message || this.state.error)}
            </pre>
            <button
              type="button"
              onClick={() => window.location.reload()}
              style={{ marginTop: 12, padding: '8px 14px', borderRadius: 10, border: '1px solid #e2e8f0', background: '#fff', cursor: 'pointer' }}
            >
              Recharger
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
